var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelmet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.6602H21V24.6602H23V13.6602Z",
    fill: "#DCDCE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34668 12.2779C3.34668 9.31998 4.52172 6.48319 6.61329 4.39161C8.70487 2.30004 11.5417 1.125 14.4996 1.125C17.4575 1.125 20.2943 2.30004 22.3859 4.39161C24.4775 6.48319 25.6525 9.31998 25.6525 12.2779H14.4996L10.0288 16.7487H3.34668V12.2779Z",
    fill: "#AAAAB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0213 18.6602H3.23579C2.90804 18.6602 2.59371 18.5292 2.36195 18.296C2.1302 18.0628 2 17.7466 2 17.4168C2 17.0871 2.1302 16.7708 2.36195 16.5376C2.59371 16.3045 2.90804 16.1735 3.23579 16.1735H9.99555L14.4815 11.6602H25.7642C26.092 11.6602 26.4063 11.7912 26.638 12.0243C26.8698 12.2575 27 12.5737 27 12.9035C27 13.2332 26.8698 13.5495 26.638 13.7827C26.4063 14.0158 26.092 14.1468 25.7642 14.1468H15.5072L11.0213 18.6602Z",
    fill: "#AAAAB1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.6602H9V27.6602H11V18.6602Z",
    fill: "#DCDCE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.6602H8V25.6602H12V23.6602Z",
    fill: "#AAAAB1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.6602H20V22.6602H24V20.6602Z",
    fill: "#AAAAB1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.66016H7V8.66016H13V7.66016Z",
    fill: "#F5F5FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.66016H7V10.6602H13V9.66016Z",
    fill: "#F5F5FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.66016H7V9.66016H13V8.66016Z",
    fill: "#DCDCE4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.6ba6560280083c6b3c93caf050c28ddf.svg";
export { ForwardRef as ReactComponent };